import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/AuthContext.jsx';
import Nav from './components/Nav.jsx';
import BugBotWidget from './components/BugBotWidget.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import CreateOrder from './pages/CreateOrder.jsx';
import OrderDetail from './pages/OrderDetail.jsx';
import ApprovalsQueue from './pages/ApprovalsQueue.jsx';
import AdminProducts from './pages/AdminProducts.jsx';
import SalesCreditReport from './pages/SalesCreditReport.jsx';
import Reps from './pages/Reps.jsx';
import MyQRCode from './pages/MyQRCode.jsx';

function RequireAdmin({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/" replace />;
}

// Reps (2026-09-21) only have backend access to POST /orders and the
// product/coupon catalog -- Dashboard (GET /orders) and Order Detail
// (GET /orders/:id) would just 403. Bounce a rep who lands on either
// (direct URL, a stale bookmark, browser back) to the one page that
// works for them, rather than showing a broken screen.
function RequireCsr({ children }) {
  const { isRep } = useAuth();
  return isRep ? <Navigate to="/orders/new" replace /> : children;
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) return <p style={{ padding: 24 }}>Loading…</p>;
  if (!user) return <Login />;

  return (
    <div className="app-shell">
      <Nav />
      <main className="main">
        <Routes>
          <Route
            path="/"
            element={
              <RequireCsr>
                <Dashboard />
              </RequireCsr>
            }
          />
          <Route path="/orders/new" element={<CreateOrder />} />
          <Route
            path="/orders/:id"
            element={
              <RequireCsr>
                <OrderDetail />
              </RequireCsr>
            }
          />
          <Route path="/my-qr-code" element={<MyQRCode />} />
          <Route
            path="/approvals"
            element={
              <RequireAdmin>
                <ApprovalsQueue />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/products"
            element={
              <RequireAdmin>
                <AdminProducts />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/sales-credit"
            element={
              <RequireAdmin>
                <SalesCreditReport />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/reps"
            element={
              <RequireAdmin>
                <Reps />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <BugBotWidget />
    </div>
  );
}
